<script lang="ts" setup>
import MPButton from "../forms/MPButton.vue";

const { coverImage, isOpen } = defineProps<{
  coverImage: string;
  isOpen: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();
</script>
<template>
  <article
    :style="{
      backgroundImage: `linear-gradient(to bottom left, rgba(0, 0, 0, 0.00) 5%, #000 80%),
        url(${coverImage})`,
    }"
  >
    <div v-if="isOpen" class="header">
      <span class="close">
        <MPButton
          icon="ri-arrow-down-s-line"
          iconOnly
          version="transparent"
          @click="emit('close')"
        />
      </span>
      <slot name="header" />
    </div>
    <div class="content">
      <slot name="content" />
    </div>
    <div v-if="isOpen" class="actions">
      <slot name="actions" />
    </div>
  </article>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";

article {
  display: flex;
  flex-direction: column;
  background-size: cover;
  background-position: center;
  border-radius: 0.75rem;
  overflow: hidden;
  min-height: 100%;
}

.header {
  padding: 2rem 2rem 0;
  display: flex;
  justify-content: space-between;
}

.header:deep(button) {
  margin: 0;
}

.header .close:deep(button) {
  padding: 0 0.25rem !important;
}

.header .close:deep(button i) {
  font-size: 2rem;
}

.content {
  cursor: pointer;
  display: block;
  color: white;
  line-height: 1;
  padding: 1.5rem 1.25rem 1.25rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: end;
  @mixin screen md {
    padding: 2rem 2rem 1.5rem;
  }
  &:deep(small) {
    color: var(--color-rose-500);
    font-weight: 700;
    font-size: var(--typeface-small);
    margin: 0.5rem 0 0 0;
  }

  &:deep(h4) {
    margin: 0.5rem 0 0 0;
  }

  &:deep(p) {
    display: none;
    margin: 0.75rem 0 0.25rem 0;
    line-height: 1.5;
    @mixin screen sm {
      display: block;
    }
  }
  &:deep(a) {
    margin: 1rem 0 0 0;
  }
  &:deep(.spot-link) {
    display: block;
    box-sizing: content-box;
    /*margin-top: auto !important;*/
    min-height: calc(100% - 4.5rem);
    display: flex;
    flex-direction: column;
    justify-content: end;
  }
}

.actions {
  padding: 0 2rem 2rem;
  &:deep(button) {
    display: block;
    width: 100%;
  }
}
</style>
